import { render, staticRenderFns } from "./AvailabilityRequest.vue?vue&type=template&id=bcb83dec&scoped=true"
import script from "./AvailabilityRequest.vue?vue&type=script&lang=js"
export * from "./AvailabilityRequest.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityRequest.vue?vue&type=style&index=0&id=bcb83dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb83dec",
  null
  
)

export default component.exports